const imageRegex = /[^/]+(gif|jpg|png|svg)$/;

const isImage = (src: string): boolean => {
  let dotIdx: number = src.lastIndexOf(".");
  let ext: string = src.substring(dotIdx);

  return imageRegex.test(ext);
};

export default isImage;